// extracted by mini-css-extract-plugin
module.exports = {"btn":"BackToTop_btn__6d14k"};